import { render } from "./feature_section.html?vue&type=template&id=713687b2&external"
import script from "./feature_section.js?vue&type=script&lang=js&external"
export * from "./feature_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__